import { useState } from "react";
import { faqItems } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-32 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700">
              <i className="ri-question-line text-base" aria-hidden="true"></i>
              FAQ
            </span>
            <h2 className="font-heading mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              关于 17吃瓜 的更新、订阅、投稿与内容原则，这里整理了最常被问到的问题。如果没有找到答案，欢迎随时联系我们。
            </p>
            <a
              href="#about"
              className="mt-5 inline-flex whitespace-nowrap items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-900"
            >
              了解内容原则 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "FAQPage",
                  mainEntity: faqItems.map((f) => ({
                    "@type": "Question",
                    name: f.q,
                    acceptedAnswer: { "@type": "Answer", text: f.a },
                  })),
                }),
              }}
            />
            <div className="space-y-3">
              {faqItems.map((item, i) => {
                const open = openIndex === i;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                      open ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-start gap-3">
                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-100 text-[11px] font-bold text-primary-700">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`ri-add-line shrink-0 text-lg text-foreground-400 transition-transform duration-300 ${
                          open ? "rotate-45 text-primary-500" : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}